<template>
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 287.57 285.95" fill="currentColor">
        <path d="M287.56,225.55c0,5.94-6.14,9.83-11.35,9.83H11.51c-5.62,0-11.51-4.3-11.51-10.2V42.7c0-5.77,6.27-9.71,11.3-9.72l44.24-.06V4.43C55.54,1.97,57.52.11,60.17,0h141.92c2.32.24,4.37,2.16,4.37,4.36v20.83s23.35.4,23.35.4c2.19.21,2.8,5.3,2.28,7.33l43.62.02c5.17,0,11.86,3.63,11.86,9.81v182.8ZM83.83,25.25h113.56s.03-16.1.03-16.1H64.62s0,23.77,0,23.77h16.82c-.5-3.16-.33-5.59,2.39-7.67ZM149.54,193.94l-64.09.02c-2.27.04-3.83-1.63-4.21-3.8l.04-20.98-21.17-.05c-2.52,0-4.5-1.97-4.58-4.61V48.65s-43.93.01-43.93.01l.05,158.1h264.45s0-158.09,0-158.09h-43.93s.02,79.22.02,79.22c-.18,1.83-.88,3.5-2.33,4.61l-80.33,61.45ZM81.27,160V48.65s-16.66,0-16.66,0v111.42s16.66-.07,16.66-.07ZM122.55,83.79c2.21,2.11,5.01,2.02,6.91-.22l22.65-26.7c1.69-1.99,1.14-4.76-.29-6.21-1.68-1.69-4.84-1.72-6.46.18l-19.78,23.2-9.05-8.58c-1.86-1.77-5.13-1.59-6.72.33-1.17,1.41-1.34,4.56.25,6.07l12.51,11.93ZM208.42,106.91c2.53,0,4.04-3.23,3.95-4.71-.08-1.35-1.54-4.24-3.46-4.24l-104.54.02c-2.5,0-3.62,3.93-3.13,5.5s2.23,3.47,4.55,3.46l102.64-.03ZM146.89,133.26c2.77,0,4.77-1.69,5.04-4.28.17-1.59-1.3-4.83-3.51-4.83l-44.16.05c-1.94,0-3.34,3.42-3.18,4.86s1.85,4.15,3.84,4.15l41.98.05ZM154.45,178.82l50.88-38.94-57.34,16.67c4.49,6.77,6.37,14.15,6.47,22.27Z"/>
        <polygon points="203.16 285.94 84.56 285.95 84.49 266.69 100.64 266.59 100.62 239.7 187.04 239.69 187.09 266.62 203.19 266.64 203.16 285.94"/>
    </svg>
</template>

<style>
.employvt-claimant-cls-1 {
    fill: #fff;
}

.draw-border:hover .employvt-claimant-cls-1 {
    fill: currentColor !important;
}

:deep(.employvt-claimant-cls-1) {
    transition: fill .2s ease;
}
</style>

<script>
export default {
    name: 'vdolEmployVtClaimantLogo',
}
</script>